import { render, staticRenderFns } from "./ProductFooter.vue?vue&type=template&id=4818b60a&scoped=true&"
import script from "./ProductFooter.vue?vue&type=script&lang=js&"
export * from "./ProductFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProductFooter.vue?vue&type=style&index=0&id=4818b60a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818b60a",
  null
  
)

export default component.exports